import { Button, styled } from "@mui/material"
import type { ButtonProps } from "@mui/material"

// Scheme-aware app CSS vars, not theme.palette.* — cssVariables freezes those to the light scheme inside a
// styled() callback.
//
// The hover selector has to mirror the global MuiButton override in styles/material.js, which targets
// `&.MuiButton-text:not(.MuiButton-colorPrimary):hover`. A plain `&:hover` here loses to it on specificity
// and the pill keeps the theme's wash instead of this one.
const PillButton = styled(Button)(({ theme }) => ({
  alignSelf: "flex-start",
  textTransform: "none",
  color: "var(--app-text-secondary)",
  border: "1px solid var(--app-overlay-border)",
  borderRadius: 999,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  "&.MuiButton-text:not(.MuiButton-colorPrimary):hover, &.MuiButton-outlined:not(.MuiButton-colorPrimary):hover": {
    color: "var(--app-text-primary)",
    backgroundColor: "var(--app-subtle-hover-surface)",
    borderColor: "var(--app-overlay-border)",
  },
}))

export function SkillNavButton(props: ButtonProps) {
  return <PillButton size="small" color="inherit" {...props} />
}
